function nameInBracketStyle(chiName, engName) {
	if(!engName){
		return null;
	}
	return engName + (chiName ? ` (${chiName})` : "");
}

export {
	nameInBracketStyle
}